import React, { useState, useEffect } from 'react';
import { entregaService, vinculoChipService } from '../services/api';
import { jsPDF } from 'jspdf';

function EntregaLista({ onEditar, tipo }) {
    const [entregas, setEntregas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        carregarEntregas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const carregarEntregas = async () => {
        try {
            setLoading(true);
            const response = await entregaService.listarTodas();
            setEntregas(response.data);
            setErro(null);
        } catch (error) {
            setErro('Erro ao carregar entregas');
        } finally {
            setLoading(false);
        }
    };

    const handleMudarStatus = async (entrega, novoStatus) => {
        if (window.confirm(`Alterar status para "${novoStatus}"?`)) {
            try {
                await entregaService.atualizar(entrega.id.imei, entrega.id.registro, {
                    ...entrega,
                    status: novoStatus
                });
                carregarEntregas();
            } catch (error) {
                alert('Erro ao atualizar status');
            }
        }
    };

    const gerarTermoPDF = async (entrega) => {
        // ✅ busca chip atual do celular — pega iccid, número de linha e operadora
        let chipIccid = '';
        let chipNumeroLinha = '';
        let chipOperadora = '';
        try {
            const resChip = await vinculoChipService.chipAtualDoCelular(entrega.id.imei);
            if (resChip.data && resChip.data.chip) {
                chipIccid = resChip.data.chip.iccid || '';
                chipNumeroLinha = resChip.data.chip.numeroLinha || '';
                chipOperadora = resChip.data.chip.operadora || '';
            }
        } catch (e) {
            chipIccid = '';
            chipNumeroLinha = '';
            chipOperadora = '';
        }

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 20;
        const contentWidth = pageWidth - margin * 2;
        let y = 20;

        const colaborador = entrega.colaborador || {};
        const celular = entrega.celular || {};
        const acessorios = entrega.acessorios || '';

        const bold = () => doc.setFont('helvetica', 'bold');
        const normal = () => doc.setFont('helvetica', 'normal');
        const size = (s) => doc.setFontSize(s);

        // ===== CABEÇALHO =====
        bold(); size(12);
        doc.text('TRANSPIRATININGA LOGÍSTICA E LOCAÇÃO DE VEÍCULOS LTDA.', pageWidth / 2, y, { align: 'center' });
        y += 7;

        normal(); size(10);
        doc.text('CNPJ: 59.275.594/0001-96', pageWidth / 2, y, { align: 'center' });
        y += 10;

        bold(); size(11);
        doc.text('TERMO DE USO – REGRAS E PROCEDIMENTOS PARA UTILIZAÇÃO', pageWidth / 2, y, { align: 'center' });
        y += 6;
        doc.text('DE TELEFONE CELULAR', pageWidth / 2, y, { align: 'center' });
        y += 12;

        // ===== TABELA COLABORADOR =====
        doc.rect(margin, y, contentWidth, 9);
        bold(); size(10);
        doc.text(`USUÁRIO: ${(colaborador.nome || '').toUpperCase()}`, margin + 3, y + 6);
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`MATRÍCULA: ${colaborador.registro || ''}`, margin + 3, y + 6);
        const dataAdmissao = colaborador.dataAdmissao
            ? new Date(colaborador.dataAdmissao + 'T00:00:00').toLocaleDateString('pt-BR')
            : '';
        doc.text(`DATA DE ADMISSÃO: ${dataAdmissao}`, margin + contentWidth / 2 + 3, y + 6);
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`CARGO: ${(colaborador.cargo || '').toUpperCase()}`, margin + 3, y + 6);
        doc.text(`DEPARTAMENTO: ${(entrega.departamento || colaborador.departamento || '').toUpperCase()}`, margin + contentWidth / 2 + 3, y + 6);
        y += 14;

        // ===== TABELA CELULAR =====
        doc.rect(margin, y, contentWidth, 9);
        bold(); size(10);
        doc.text('CELULAR', pageWidth / 2, y + 6, { align: 'center' });
        y += 9;

        // ✅ número de linha e operadora agora vêm do chip
        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`NÚMERO DA LINHA: ${chipNumeroLinha}`, margin + 3, y + 6);
        doc.text(`OPERADORA: ${chipOperadora}`, margin + contentWidth / 2 + 3, y + 6);
        y += 9;

        const temCarregador = acessorios.toLowerCase().includes('carregador') ? 'SIM' : 'NÃO';
        const temFone = acessorios.toLowerCase().includes('fone') ? 'SIM' : 'NÃO';
        const temCapa = acessorios.toLowerCase().includes('capinha') || acessorios.toLowerCase().includes('capa') ? 'SIM' : 'NÃO';
        const temAdaptador = acessorios.toLowerCase().includes('adaptador') ? 'SIM' : 'NÃO';
        const temPelicula = acessorios.toLowerCase().includes('película') || acessorios.toLowerCase().includes('pelicula') ? 'SIM' : 'NÃO';

        const linhasDetalhes = [
            `Marca: ${celular.marca || ''}`,
            `Modelo: ${celular.modelo || ''}`,
            `IMEI: ${celular.imei || entrega.id?.imei || ''}`,
            `FONE: ${temFone}`,
            `CARREGADOR: ${temCarregador}`,
            `ADAPTADOR DE TOMADA: ${temAdaptador}`,
            `CAPA PROTETORA CELULAR: ${temCapa}`,
            `PELÍCULA: ${temPelicula}`,
            `CHIP: ${chipIccid}`,
        ];

        const alturaDetalhes = linhasDetalhes.length * 5 + 4;
        doc.rect(margin, y, contentWidth, alturaDetalhes);
        normal(); size(9);
        linhasDetalhes.forEach((linha, i) => {
            doc.text(linha, margin + 3, y + 5 + i * 5);
        });
        y += alturaDetalhes + 5;

        doc.rect(margin, y, contentWidth, 9);
        bold(); size(10);
        doc.text('NOTEBOOK: N/A', margin + 3, y + 6);
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text('MARCA/MODELO: N/A', margin + 3, y + 6);
        doc.text('SÉRIE: N/A', margin + contentWidth / 2 + 3, y + 6);
        y += 14;

        // ===== CLÁUSULAS =====
        normal(); size(9);

        const clausulas = [
            '1- O fornecimento dos aparelhos acima descritos tem por finalidade facilitar e permitir a imediata comunicação entre o colaborador da empresa, o cliente, e a base administrativa, agilizando o atendimento das solicitações de serviços. O USUÁRIO-COLABORADOR ficará de posse dos aparelhos, tendo em vista o uso exclusivo para prestação de serviços profissionais e não a propriedade do equipamento, sendo terminantemente proibido o empréstimo, aluguel ou cessão destes a terceiros.',
            '2- É obrigatório o porte do aparelho celular apenas durante toda a jornada de trabalho, devendo o USUÁRIO-COLABORADOR mantê-lo preso a sua cintura ou outra forma que desejar desde que fique ao alcance de sua campainha sonora ou possa sentir sua vibração.',
            '3- Nas oportunidades em que a natureza da função ou do serviço externo prestado pelo USUÁRIO-COLABORADOR justificar, poderá ser monitorada pela EMPRESA a localização exata do colaborador nos aparelhos cujos modelos são compatíveis com a tecnologia de rastreabilidade remota via GPS, bem como para verificação por parte da EMPRESA dos horários de início e término da jornada de trabalho, e intervalo para descanso do USUÁRIO-COLABORADOR.',
            '4- O aparelho celular somente poderá ser utilizado como rádio comunicador e para receber chamadas, ficando expressamente vedado seu uso para realizar ligações pessoais, mesmo em se tratando de assuntos relativos às atribuições e responsabilidades de sua função. Eventuais débitos que vierem a ser registrados no aparelho decorrente de seu uso, em confronto com as regras aqui estabelecidas serão de responsabilidade exclusiva do USUÁRIO-COLABORADOR e posteriormente descontadas de seu salário.',
            '5- É de responsabilidade do USUÁRIO-COLABORADOR cuidar, zelar e manter pela conservação do aparelho celular, utilizando-o dentro das regras básicas recomendadas pelo fabricante, sob pena de arcar com as despesas de reposição ou conserto em função de desleixo, falta de cuidado e descaso.',
            '6- Em caso de perda, extravio, furto ou roubo dos aparelhos o USUÁRIO-COLABORADOR deverá, de imediato, avisar a área da controladoria da empresa.',
            '7- Estas regras e procedimentos integram o contrato de trabalho do USUÁRIO-COLABORADOR.',
            '8- A EMPRESA poderá, a qualquer tempo, independentemente de comunicado prévio ou anuência do USUÁRIO-COLABORADOR, requisitar de imediato os aparelhos para inspeção e vistoria do seu conteúdo.',
            '9- O USUÁRIO-COLABORADOR declara neste ato que: a) Recebeu os aparelhos, com todos dos itens originais que o compõem. b) Está ciente de que não deve instalar qualquer senha nos aparelhos sob o seu uso que venha a inviabilizar o uso posterior por pessoa diversa. c) Não deve, sob hipótese alguma, violar o lacre que envolve o chip do celular com o fim de uso do aparelho em questão para fins pessoais. d) Deve respeitar as normas de segurança e restrições de sistema impostas pelos sistemas de segurança implantados pela empresa. e) Estar ciente de que não é permitida a navegação aos sites pertencentes às categorias: pornográfico, compartilhamento de arquivos, pornografia infantil, apologia ao terrorismo, apologia às drogas, de relacionamento (facebook, instagram, twitter etc.), violência, violação de direito autoral, áudio e vídeo, conteúdo impróprio, ofensivo, ilegal, discriminatório e similares.',
            '10- O USUÁRIO-COLABORADOR deverá ressarcir inteiramente os danos causados. Se o dano inviabilizar por completo o uso dos aparelhos, deverá o USUÁRIO-COLABORADOR arcar com os custos integrais de um aparelho novo, de modelo igual ou similar, no importe a ser determinado pela EMPRESA.',
            '11- Qualquer problema referente ao uso dos aparelhos da empresa, deverá, imediatamente, ser relatado à mesma.',
            '12- O USUÁRIO-COLABORADOR assumirá a responsabilidade por qualquer dano causado por sua responsabilidade nos aparelhos de propriedade da empresa.',
            '13- O USUÁRIO-COLABORADOR assumirá a responsabilidade pelo dano que possa causar caso não venha a cumprir o disposto neste termo de responsabilidade. Declarando, nesta data, ter ciência e estar de acordo com os procedimentos acima descritos, comprometendo-me a respeitá-los e cumpri-los plena e integralmente.',
        ];

        clausulas.forEach((clausula) => {
            normal(); size(9);
            const linhas = doc.splitTextToSize(clausula, contentWidth);
            if (y + linhas.length * 4.5 + 5 > 275) {
                doc.addPage();
                y = 20;
            }
            doc.text(linhas, margin, y);
            y += linhas.length * 4.5 + 4;
        });

        // ===== DATA E ASSINATURA =====
        if (y + 35 > 275) {
            doc.addPage();
            y = 20;
        }

        y += 8;
        const dataEntrega = entrega.dataEntrega
            ? new Date(entrega.dataEntrega + 'T00:00:00').toLocaleDateString('pt-BR', {
                day: '2-digit', month: 'long', year: 'numeric'
              })
            : '_____ de _____________ de _____';

        normal(); size(10);
        doc.text(`São Caetano do Sul, ${dataEntrega}`, margin, y);
        y += 18;

        doc.line(margin, y, margin + 90, y);
        y += 5;
        bold(); size(10);
        doc.text((colaborador.nome || '').toUpperCase(), margin, y);

        const nomeArquivo = `termo-${(colaborador.nome || 'colaborador').replace(/\s+/g, '-').toLowerCase()}-${entrega.id?.imei || ''}.pdf`;
        doc.save(nomeArquivo);
    };

    if (loading) return <div className="text-center">Carregando...</div>;
    if (erro) return <div className="alert alert-danger">{erro}</div>;

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">📦 Lista de Entregas</h5>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>IMEI</th>
                                <th>Modelo</th>
                                <th>Colaborador</th>
                                <th>Departamento</th>
                                <th>Data Entrega</th>
                                <th>Status</th>
                                {tipo === 'ADMIN' && <th className="text-center">Ações</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {entregas.length === 0 ? (
                                <tr>
                                    <td colSpan={tipo === 'ADMIN' ? 7 : 6} className="text-center text-muted">
                                        Nenhuma entrega cadastrada
                                    </td>
                                </tr>
                            ) : (
                                entregas.map((entrega) => (
                                    <tr key={`${entrega.id.imei}-${entrega.id.registro}`}>
                                        <td>{entrega.celular?.imei || entrega.id.imei}</td>
                                        <td>{entrega.celular?.modelo || '-'}</td>
                                        <td>{entrega.colaborador?.nome || '-'}</td>
                                        <td>{entrega.departamento || '-'}</td>
                                        <td>{new Date(entrega.dataEntrega).toLocaleDateString('pt-BR')}</td>
                                        <td>
                                            <span className={`badge ${
                                                entrega.status === 'ativo' ? 'bg-success' :
                                                entrega.status === 'devolvido' ? 'bg-secondary' :
                                                'bg-danger'
                                            }`}>
                                                {entrega.status}
                                            </span>
                                        </td>
                                        {tipo === 'ADMIN' && (
                                            <td className="text-center text-nowrap">
                                                <button onClick={() => onEditar(entrega)} className="btn btn-sm btn-warning me-1">✏️ Editar</button>
                                                <button onClick={() => gerarTermoPDF(entrega)} className="btn btn-sm btn-primary me-1">📄 Termo</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'ativo')} className="btn btn-sm btn-success me-1" disabled={entrega.status === 'ativo'}>✅ Ativo</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'devolvido')} className="btn btn-sm btn-secondary me-1" disabled={entrega.status === 'devolvido'}>↩️ Devolvido</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'atrasado')} className="btn btn-sm btn-danger" disabled={entrega.status === 'atrasado'}>⚠️ Atrasado</button>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default EntregaLista;